<div class="container-fluid wrapper-page" id="doctorarea">
  <div>
    <h5>
      <a href="javascript:void(0)"
        ><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK </i></a
      >
    </h5>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <ul role="tablist">
            <li role="tab">
              <a
                class="nav-link"
                (click)="patdashAssignTab('personalInformation')"
                [ngClass]="{
                  active: patdashCurrentTab == 'personalInformation'
                }"
                href="javascript:void(0)"
                role="tab"
                ><span class="number">1.</span>Personal Information</a
              >
            </li>
            <li role="tab">
              <a
                href="javascript:void(0)"
                (click)="patdashAssignTab('appointments')"
                [ngClass]="{ active: patdashCurrentTab == 'appointments' }"
                class="nav-link"
                ><span class="number">2.</span>Appointments</a
              >
            </li>
            <li role="tab">
              <a
                href="javascript:void(0)"
                (click)="patdashAssignTab('discountCoupon')"
                [ngClass]="{ active: patdashCurrentTab == 'discountCoupon' }"
                aria-controls="steps-uid-0-p-2"
                class="nav-link"
              >
                <span class="number">3.</span>Discount Coupon</a
              >
            </li>
          </ul>

          <!-- ===============Personal INFORMATION========================== -->
          <ng-container *ngIf="patdashCurrentTab == 'personalInformation'">
            <section class="mt-3 ml-2 align-items-center">
              <div class="row">
                <div class="col-md-12">
                  <div class="card m-b-30 fix">
                    <div class="card-body">
                      <div class="row">
                        <!-- <div class="col-md-6">
                            <h6 class="heading_color">Personal DETAILS</h6>
                          </div> -->
                      </div>
                      <div class="row" *ngIf="patient">
                        <div class="col-md-12 custom_column">
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold"
                                >Patient Name :</label
                              >
                            </div>
                            <div class="col-8 pl-0 pr-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                  patient.first_name === null &&
                                  patient.last_name === null
                                    ? "Not
                                Available"
                                    : patient.first_name +
                                      " " +
                                      patient.last_name
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold"
                                >D.O.B :
                              </label>
                            </div>
                            <div class="col-8 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                  patient.dob === null
                                    ? "Not Available"
                                    : (patient.dob | date: "dd-MMM-yyyy")
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold"
                                >Gender :
                              </label>
                            </div>
                            <div class="col-8 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                  patient.gender === null
                                    ? "Not Available"
                                    : patient.gender
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold"
                                >Email Id :
                              </label>
                            </div>
                            <div class="col-8 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                  patient.email_id === null
                                    ? "Not Available"
                                    : patient.email_id
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold"
                                >Contact Number :
                              </label>
                            </div>
                            <div class="col-8 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                  patient.contact_no === null
                                    ? "Not Available"
                                    : patient.contact_no
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>

          <!----======== APPOINTMENT=========================  -->
          <ng-container *ngIf="patdashCurrentTab == 'appointments'">
            <section class="mt-3 ml-2 align-items-center">
              <div class="row">
                <div class="d-flex ml-3 align-middle">
                  <button
                    type="button"
                    (click)="
                      upcoming = true; getSuperadminPatientApt('upcoming')
                    "
                    class="btn btn-lg h-50 btn-primary mt-3"
                    style="font-size: 14px"
                    id="upcoming"
                    [ngClass]="{
                      'btn-primary': appointmentType === 'upcoming'
                    }"
                  >
                    Upcoming Appointment
                  </button>
                  <button
                    type="button"
                    (click)="upcoming = false; getSuperadminPatientApt('past')"
                    class="btn btn-lg h-50 btn-primary mt-3"
                    style="margin-left: 15px; font-size: 14px"
                    id="completed"
                    [ngClass]="{ 'btn-primary': appointmentType === 'past' }"
                  >
                    Completed Appointment
                  </button>
                  <button
                    type="button"
                    (click)="upcoming = false; getSuperadminPatientApt('all')"
                    class="btn btn-lg h-50 btn-primary mt-3"
                    style="margin-left: 15px; font-size: 14px"
                    id="all"
                    [ngClass]="{ 'btn-primary': appointmentType === 'all' }"
                  >
                    All Appointment
                  </button>
                </div>
                <div class="col-md-5"></div>
                <div class="d-flex" *ngIf="patAppointments">
                  <div
                    class="pl-0 pr-0 align-items-center pull-right mt-3 ml-5"
                  >
                    <p class="font-weight-100">
                      <button (click)="exportAsXLSX()">
                        <i
                          class="fa fa-file-excel-o mr-1"
                          style="font-size: 23px; color: blue"
                        ></i>
                      </button>
                    </p>
                  </div>
                  <div class="pl-0 pr-0 ml-2 pull-right mt-4">
                    <label class="font-weight-bold"
                      >Click Icon to Download</label
                    >
                  </div>
                </div>
              </div>
              <br />
              <!--<div class="d-flex">
                <div class="pl-0 pr-0">
                  <label class="font-weight-bold">Patient Name :</label>
                </div> &nbsp;&nbsp;
                <div class="pl-0 pr-0">
                  <p class="font-weight-100">
                    {{ patient?.first_name }}
                    {{ patient?.last_name }}
                  </p>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-4"></div>

              </div>-->
              <br />

              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col">APT ID</th>
                    <th scope="col">APT DATE</th>
                    <th scope="col">APT TIME</th>
                    <th scope="col">PATIENT NAME</th>
                    <th scope="col">PHYSICIAN NAME</th>
                    <th scope="col">APT TYPE</th>
                    <th scope="col">STATUS</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let data of patAppointments">
                    <td scope="row">
                      {{ data.aptid === null ? "Not Available" : data.aptid }}
                    </td>
                    <td>
                      {{
                        data.apdate === null
                          ? "Not Available"
                          : (data.apdate | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td>
                      {{ data.aptime === null ? "Not Available" : data.aptime }}
                    </td>
                    <td>
                      {{
                        data.patfirstname === null && data.patlastname === null
                          ? "Not
                      Available"
                          : data.patfirstname + " " + data.patlastname
                      }}
                    </td>
                    <td>
                      {{
                        data.phyfirstname === null && data.phylastname === null
                          ? "Not
                      Available"
                          : data.phyfirstname + " " + data.phylastname
                      }}
                    </td>
                    <td>
                      {{
                        data.apttype === null
                          ? "Not Available"
                          : data.apttype.replace("_", " ").toUpperCase()
                      }}
                    </td>
                    <td>
                      {{
                        data.schedule_stat === null
                          ? "Not
                      Available"
                          : data.schedule_stat.replace("_", " ").toUpperCase()
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <br />
              <br />

              <br />
            </section>
          </ng-container>

          <!----======== Discount Coupon Tab =========================  -->
          <ng-container *ngIf="patdashCurrentTab == 'discountCoupon'">
            <section class="mt-3 ml-2 align-items-center">
              <br />
              <form [formGroup]="patCouponForm">
                <div class="row">
                  <div class="col-sm-2 ml-5">
                    <label class="f-s-13 mt-3 font-weight-bold"
                      >Coupon ID :</label
                    >
                  </div>
                  <div class="col-sm-7">
                    <select
                      class="form-control font-weight-100"
                      formControlName="patCoupon"
                    >
                      <option
                        *ngFor="let couponRecord of allCouponDetails"
                        [ngValue]="couponRecord"
                      >
                        {{ couponRecord.id }} - {{ couponRecord.description }} -
                        {{ couponRecord.discount_percent }}%
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-2">
                    <button
                      type="button"
                      class="btn btn-primary btn-model w-100 mt-2 ml-2"
                      [disabled]="patCouponForm.invalid"
                      (click)="addCoupon()"
                    >
                      ADD
                    </button>
                  </div>
                </div>
              </form>
              <br />
              <br />

              <div class="d-flex">
                <div class="pl-0 pr-0">
                  <label class="font-weight-bold">Patient Name :</label>
                </div>
                &nbsp;&nbsp;
                <div class="pl-0 pr-0">
                  <p class="font-weight-100">
                    {{ patient?.first_name }}
                    {{ patient?.last_name }}
                  </p>
                </div>
              </div>
              <br />
              <table
                class="table table-striped table-bordered"
                *ngIf="patCouponDetails"
              >
                <thead>
                  <tr>
                    <th scope="col">CREATED DATE</th>
                    <th scope="col">COUPON ID</th>
                    <th scope="col">VALIDITY FROM</th>
                    <th scope="col">VALIDITY TO</th>
                    <th scope="col">DESCRIPTION</th>
                    <th scope="col" class="text-center">USED ON</th>
                    <th scope="col" class="text-center">SCOPE</th>
                    <th scope="col" class="text-center">STATUS</th>
                    <th scop="col"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let data of patCouponDetails; let j = index">
                    <td class="align-middle">
                      {{
                        data.created_at === null
                          ? "Not Available"
                          : (data.created_at | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td class="align-middle">
                      {{ data.id === null ? "Not Available" : data.id }}
                    </td>
                    <td class="align-middle">
                      {{
                        data.valid_from === null
                          ? "Not Available"
                          : (data.valid_from | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td class="align-middle">
                      {{
                        data.valid_to === null
                          ? "Not Available"
                          : (data.valid_to | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td class="text-wrap col-md-2 align-middle">
                      {{
                        data.description === null
                          ? "Not
                      Available"
                          : data.description
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        data.used_at === null
                          ? "-"
                          : (data.used_at | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td class="align-middle text-center">{{ data?.scope }}</td>
                    <td class="align-middle text-center">
                      {{ data.active ? "Active" : "InActive" }}
                    </td>
                    <td *ngIf="data.scope == 'IND'" class="align-middle">
                      <button
                        type="button"
                        class="btn btn-primary btn-model pull-right"
                        (click)="removeCoupon(j)"
                        [disabled]="!data.active || expiryCheck(j)"
                      >
                        REMOVE
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
